export const appConfig = { externalURL: '#{HCC.Portal.UI.APIBaseURL}#'};

// Worked !!
//export const appConfig = { externalURL: 'https://portal.test.homecareconnect.com'};
// Comment out  6/24/26 for testing Token Replacement
//export const appConfig = { externalURL: 'https://portal.homecareconnect.com'};

// Vite only exposes env vars prefixed with VITE_ (others are silently ignored)
// Set VITE_API_BASE_URL in .env or as a pipeline env var before running: yarn build
/*
export const appConfig = {
    externalURL: import.meta.env.VITE_API_BASE_URL || '',
};

 */